//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

(function() {
  const content = angular.module('curalate');

  content.component('contentLibraryUsersFilterSection', {
    bindings: {
      readyCallback: '&',
    },
    require: {
      searchFilterSet: '^searchFilterSet',
    },
    template: require('@legacy-components/content/content-library-users-filter-section.html'),
    controller: [
      '$scope',
      'CONTENT_LIBRARY_CONTENT_GROUPS',
      'CoreApiService',
      'SearchFilterService',
      'SessionVarsService',
      function($scope,
                     CONTENT_LIBRARY_CONTENT_GROUPS,
                     CoreApiService,
                     SearchFilterService,
                     SessionVarsService) {
        const self = this;
        self.TEAM_VALUE = CONTENT_LIBRARY_CONTENT_GROUPS.TEAM;
        self.ALL_VALUE = CONTENT_LIBRARY_CONTENT_GROUPS.ALL;
        self.MAX_USERS = 50;
        let allUsers = [];

        $scope.model = {
          me: {
            name: 'My Media',
            userId: null,
          },
          otherUsers: [],
          ready: false,
          usersSearchText: '',
          searchFilteredUsers: [],
          allTooltip: 'Items that you and your team members have:\n\n' +
                        'Uploaded\n' +
                        'Added to Media Library\n' +
                        'Labeled\n' +
                        'Product tagged\n' +
                        'Requested rights\n' +
                        'Distributed',
          teamTooltip: 'Items uploaded and added by you and your team members',
        };

        const updateUsersListFromSearchText = function() {
          const usersSearchText = $scope.model.usersSearchText.toLowerCase();
          const matchingUsers = _(allUsers).filter((user) => {
            return user.nameLowerCased.indexOf(usersSearchText) > -1;
          });

          const separated = _(matchingUsers).partition((user) => {
            return user.nameLowerCased === usersSearchText;
          });

          const exactMatch = separated[0];
          const otherMatches = separated[1];

          $scope.model.searchFilteredUsers = exactMatch.concat(otherMatches);
        };

        $scope.usersSearchTextChange = function() {
          updateUsersListFromSearchText();
        };

        $scope.clearButtonClicked = function() {
          $scope.model.usersSearchText = '';
          $scope.model.searchFilteredUsers = [];
        };

        $scope.model.findMoreUsers = function() {
          angular.element('#library-users-search-box').focus();
        };

        const onFilterUpdate = function(updateKey, updateValue, filterState) {
          const updatedFilterState = angular.copy(filterState);
          if (updateKey === 'userIds' && updateValue.length > 0) {
            updatedFilterState.contentGroup = [];
          }
          if (updateKey === 'contentGroup' && updateValue.length > 0) {
            updatedFilterState.userIds = [];
          }
          return updatedFilterState;
        };

        self.$onInit = function() {
          $scope.model.me.userId = SessionVarsService.getUserId().toString();

          CoreApiService.getUsersAsync().then((response) => {
                        // Unpack response to give users = [[{currentUser}], [{teamMember1}, {teamMember2}, ...]]
            const users = _(response).map((user) => {
              const name = [user.firstName, user.lastName].join(' ').trim();
              return {
                userId: user.id.toString(),
                name,
                nameLowerCased: name.toLowerCase(),
              };
            });

            const meAndOthers = _(users).partition((user) => {
                            // Split off current user
              return $scope.model.me.userId === user.userId;
            });

            const me = meAndOthers[0][0];
            if (me) {
              me.name += ' (you)';
              $scope.model.me = me;
            }

            allUsers = users;
            $scope.model.otherUsers = meAndOthers[1];

            $scope.model.ready = true;
            self.readyCallback();
          });

          self.searchFilterSet.registerUpdateWatcher(onFilterUpdate);
        };
      },
    ],
  });
})();
